/**
 *
 * @param {*} date
 * function to format date in month day format
 * expects a full date
 */
const formatDate = date => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const fullDate = new Date(date);
    const month = monthNames[fullDate.getMonth()];
    const day = (fullDate.getDate() < 10 ? "0" : "") + fullDate.getDate();
    return `${month} ${day}`;
};
/**
 *
 * @param {*} weight
 * takes in a weight in KG and returns in g if it's less than 1
 */
const formatWeight = weight => {
    return weight < 1 ? `${weight * 1000}g` : `${weight}kg`;
};

/**
 *
 * @param {*} item
 * takes in an item and returns a title to display on the FE
 */
const formatItemTitle = item => {
    if (item === "large") {
        return "large envelope";
    }
    if (item === "standard") {
        return "letter or postcard";
    }

    return item;
};

/**
 *
 * @param {*} price
 * excepts a price as a param and returns a number fixed to 2 decimals
 */
const formatPrice = price => {
    if (!price) {
        return "0.00";
    }
    return price.toFixed(2);
};

/**
 *
 * @param {*} e
 * takes in an input field and validate to allow only numbers, dot and/or comma
 */
const allowOnlyNumbers = e => {
    const NUMBER_DOT_COMMA = /^[\d,.]*$/;
    const fieldValue = e.target.value;
    const fieldHasCommaOrDot = fieldValue.includes(".") || fieldValue.includes(",");
    const keyIsCommaOrDot = e.key === "." || e.key === ",";

    if (!NUMBER_DOT_COMMA.test(e.key) || (keyIsCommaOrDot && fieldHasCommaOrDot)) e.preventDefault();
    e.target.value = fieldValue.replace(",", ".");
};

/**
 *
 * @param {*} e
 * takes in an input field and validate to not allow any digits
 */
const allowNoDigits = e => {
    const DIGITS = /^\d*$/;

    if (DIGITS.test(e.key)) e.preventDefault();
};

/**
 *
 * @param {*} obj
 * reusable function to push data to GTM
 * expects an object
 */
const pushDataLayer = obj => {
    window.dataLayer.push(obj);
};

/**
 *
 * @param {*} obj
 * reusable function to push virtualPageView event to GA
 * pageviewUrl : string
 * pageviewTitle : string
 */
const virtualPageView = (pageviewUrl, pageviewTitle) => {
    const GTMData = {
        event: "virtualPageView",
        pageview_url: pageviewUrl,
        pageview_title: pageviewTitle
    };
    pushDataLayer(GTMData);
};

/**
 *
 * @param {*} calcData
 * returns an object of values to reuse in the calc
 */
const productsObject = (calcData, addOn, dest) => {
    return Object.getOwnPropertyNames(addOn).length !== 0
        ? [
              {
                  name: `${calcData.ServiceName}`,
                  id: `${calcData.ServiceCode}`,
                  category: `${calcData.MailType}`,
                  weight: `${calcData.Weight}`,
                  dimension7: `${dest === undefined ? `Ireland` : dest}`,
                  brand: "AnPost",
                  position: calcData.index + 1,
                  price: `${calcData.baseLabelFee}`,
                  quantity: 1
              },
              {
                  name: calcData.addOnArr.Description,
                  id: calcData.addOnFeaturesId,
                  category: calcData.addOnArr.CategoryType,
                  weight: `${calcData.Weight}`,
                  dimension7: `${dest === undefined ? `Ireland` : dest}`,
                  brand: "AnPost",
                  price: `${calcData.addOnFeaturesFee}`,
                  quantity: 1
              }
          ]
        : [
              {
                  name: `${calcData.ServiceName}`,
                  id: `${calcData.ServiceCode}`,
                  category: `${calcData.MailType}`,
                  weight: `${calcData.Weight}`,
                  dimension7: `${dest === undefined ? `Ireland` : dest}`,
                  brand: "AnPost",
                  position: calcData.index + 1,
                  price: `${calcData.baseLabelFee}`,
                  quantity: 1
              }
          ];
};

/**
 *
 * @param {*} gram
 * converts grams to kg's
 */
const gramToKg = gram => {
    return gram / 1000;
};

// Cookie getter is an es6 version of https://www.w3schools.com/js/js_cookies.asp
const getCookie = cname => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    // split up the cookies in an array
    const cookiesArray = decodedCookie.split(";");

    // loop through the cookies
    for (let i = 0; i < cookiesArray.length; i += 1) {
        let selectedCookie = cookiesArray[i];
        while (selectedCookie.charAt(0) === " ") {
            selectedCookie = selectedCookie.substring(1);
        }
        // get the cookies you're looking for and return it
        if (selectedCookie.indexOf(name) === 0) {
            return selectedCookie.substring(name.length, selectedCookie.length);
        }
    }
    return "";
};

// Delete cookie
const deleteSetCookie = cname => {
    document.cookie = `${cname}; max-age=0`;
}

/**
 *
 * @param {string} text
 * @param {array} values
 * @param {string} key
 * loop through an array of objects to see if one of them contains a certain string
 */
const lookForMatchInArray = (text, values, key) => {
    if (!text) {
        return null;
    }
    for (let i = 0; i < values.length; i += 1) {
        if (text.toLowerCase().includes(values[i][key].toLowerCase())) {
            return values[i][key];
        }
    }

    return null;
};

// Capitalise the first letter of each word supplied
const capitaliseFirstLetters = str => {
    if (!str) return "";
    if (!str.trim()) return "";
    const updatedStr = str
        .trim()
        .toLowerCase()
        .split(" ");

    for (let i = 0, x = updatedStr.length; i < x; i += 1) {
        if (updatedStr[i][0]) {
            updatedStr[i] = updatedStr[i][0].toUpperCase() + updatedStr[i].substr(1);
        }
    }

    return updatedStr.join(" ");
};

// truncate a string
const truncateString = (input, limit) =>  {
    return input.length > limit ? `${input.substring(0, limit - 3)}...` : input;
}

// Check application code
const hasApplicationCode = (products, code) => {
    return products ? products.filter(consent => {
        // filter out global consents (not needed here)
        return consent.applicationCode === code;
    }).length > 0 : false;
}

export {
    formatDate,
    formatWeight,
    formatItemTitle,
    formatPrice,
    allowOnlyNumbers,
    allowNoDigits,
    pushDataLayer,
    productsObject,
    gramToKg,
    virtualPageView,
    getCookie,
    deleteSetCookie,
    lookForMatchInArray,
    capitaliseFirstLetters,
    truncateString,
    hasApplicationCode
};
